module.exports = __webpack_public_path__ + "img/ic_help_gray_24px.5c6dbf34.png";